import React from 'react';
import PersonProfile from './PersonProfile/PersonProfile';
import {
  ROLE_EXTERNAL_PARTNER,
  ROLE_EXTERNAL_USER,
  ROLE_STUDENT,
  ROLE_TEACHER,
} from '../../../../utils/constants/roles.js';
import useUserHasRole from '../../../../hooks/useUserHasRoles.jsx';
import ExternalPartnersEdit from '../ExternalPartners/ExternalPartnersEdit/ExternalPartnersEdit.jsx';
import ExternalUsersEdit from '../ExternalUsers/ExternalUsersEdit/ExternalUsersEdit.jsx';

const Dashboard = () => {
  const isExternalUser = useUserHasRole(ROLE_EXTERNAL_USER);
  const isExternalPartner = useUserHasRole(ROLE_EXTERNAL_PARTNER);
  const isFriUser = useUserHasRole([ROLE_STUDENT, ROLE_TEACHER]);

  return (
    <>
      {isFriUser ? (
        <PersonProfile />
      ) : isExternalPartner ? (
        <ExternalPartnersEdit from="profile" />
      ) : isExternalUser ? (
        <ExternalUsersEdit from="profile" />
      ) : null}
    </>
  );
};

export default Dashboard;
